/**
 * Central, typed access to environment variables.
 * Never read `process.env` directly outside this file.
 */
const env = {
  appName: process.env.REACT_APP_NAME || 'Anablr Enterprise',
  appEnv: process.env.REACT_APP_ENV || 'development',
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL || '',
  imageBaseUrl: process.env.REACT_APP_IMAGE_BASE_URL || '',
  apiTimeout: Number(process.env.REACT_APP_API_TIMEOUT || 30000),
  isProduction: process.env.REACT_APP_ENV === 'production',
  // Layer C payload encryption. Both flags must match the backend's
  // PAYLOAD_ENCRYPTION_ENABLED / PAYLOAD_ENCRYPTION_KEY exactly.
  //
  // This key is NOT a secret: it ships in the bundle and anyone can read it in
  // devtools. It keeps request bodies out of intermediate logs and proxy dumps,
  // and is defence in depth on top of TLS — never a substitute for it.
  payloadEncryptionEnabled: process.env.REACT_APP_PAYLOAD_ENCRYPTION_ENABLED === 'true',
  payloadEncryptionKey: process.env.REACT_APP_PAYLOAD_ENCRYPTION_KEY || '',
  // Firebase Cloud Messaging web-push VAPID public key
  // (Firebase Console → Project Settings → Cloud Messaging → Web Push
  // certificates → "Key pair"). Web-push registration is skipped when unset.
  firebaseVapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY || '',
  // Firebase web client config (Project Settings → General → Your apps).
  // Public by design — identifies the project, not a secret. The same values
  // are forwarded to the background service worker via query params.
  firebaseConfig: {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY || '',
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || '',
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || '',
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || '',
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '',
    appId: process.env.REACT_APP_FIREBASE_APP_ID || '',
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || '',
  },
};

export default env;
